export default {
  isCollapse: false,
  constantTypes: {},
  roles: {},
  register: {},
  department: {},
  register_status: ['', '已挂号', '已接诊', '已退号'],
  check_status: ['', '待缴费', '待检查', '已检查', '已退费'],
  inspect_status: ['', '待缴费', '待检查', '已检查', '已退费']
}
